
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import { PanoramaController } from "@/components/panorama.controller";

export class PanoLookLeftAction extends Action {

  /** how much to turn by */
  public _delta = 10.0;

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_LEFT,
      type:  ActionType.PANO_LEFT,
      label: 'Zoom In',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** set the turn amount (degrees) */
  public setDelta(delta: number = 10.0) {

    this._delta = delta;
  }

  /** fetch the turn amount (delta) */
  public delta(): number {

    return this._delta;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.lookLeft(this._delta);

    return true;
  }
}
